import React from "react";
import { Youtube } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer
      className="relative bg-[#050505] border-t border-white/10 py-14"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1920px] px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <Logo />
            <p className="mt-6 font-serif-italic text-white/50 text-lg max-w-sm leading-relaxed">
              Kingdom above the clouds — training, delivery, and management for
              serious aviators.
            </p>
            <a
              href="https://www.youtube.com/@elelyonair"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube-link"
              className="group mt-8 inline-flex items-center gap-3 border border-white/20 hover:border-[#FF5A00] hover:bg-[#FF5A00]/5 rounded-full px-5 py-2.5 transition-colors duration-300"
            >
              <Youtube className="w-4 h-4 text-[#FF5A00] group-hover:scale-110 transition-transform duration-300" />
              <span className="font-mono-label text-white/80 group-hover:text-white text-[11px] tracking-[0.2em]">
                Watch on YouTube · @elelyonair
              </span>
            </a>
          </div>
          <div className="flex flex-col md:items-end gap-2 font-mono-label text-white/45">
            <div>© {new Date().getFullYear()} El Elyon Air</div>
            <div>Precision · Heritage · Excellence</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
